var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Connection, VersionedTransaction } from '@solana/web3.js';
import { executeSolana } from './executeSolana';
import { bundle } from './jito';
import bs58 from 'bs58';
var TIMEOUT_MS = 30000; // 20 seconds timeout
function confirmTransactionWithTimeout(connection, signature, abortSignal) {
    return __awaiter(this, void 0, Promise, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var checkSignature = function () { return __awaiter(_this, void 0, void 0, function () {
                        var status, error_1;
                        var _a, _b, _c;
                        return __generator(this, function (_d) {
                            switch (_d.label) {
                                case 0:
                                    _d.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, connection.getSignatureStatus(signature)];
                                case 1:
                                    status = _d.sent();
                                    if (((_a = status.value) === null || _a === void 0 ? void 0 : _a.confirmationStatus) === 'confirmed' ||
                                        ((_b = status.value) === null || _b === void 0 ? void 0 : _b.confirmationStatus) === 'finalized' ||
                                        ((_c = status.value) === null || _c === void 0 ? void 0 : _c.confirmationStatus) === 'processed') {
                                        resolve();
                                    }
                                    else {
                                        setTimeout(checkSignature, 500); // Check again after 1 second
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_1 = _d.sent();
                                    reject(error_1);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    abortSignal.addEventListener('abort', function () {
                        reject(new Error('Transaction confirmation timed out'));
                    }, { once: true });
                    checkSignature();
                })];
        });
    });
}
export function executeDirectTransactionsSolana(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var connection, result, controller, timeoutId, directResultPromise, versionedTxns_1, bundleResultPromise, _c, directResult, bundleResult, hashes, jitoHash, directHash, hash, versionedTxns, bundleResult, hashes, error_2;
        var _this = this;
        var _d, _e, _f, _g;
        var transactions = _b.transactions, keypair = _b.keypair, _h = _b.hasFeesAdded, hasFeesAdded = _h === void 0 ? false : _h, _j = _b.waitForConfirmation, waitForConfirmation = _j === void 0 ? false : _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    connection = new Connection('https://mainnet.helius-rpc.com/?api-key=8bab07d6-d614-478e-ba36-c2e07ea6d720', 'confirmed');
                    result = {
                        txHash: null,
                        explorerUrl: null,
                        txHash1: null,
                        explorerUrl1: null,
                        error: null,
                    };
                    console.log('Executing Order SOLANA, transactions:', transactions);
                    controller = new AbortController();
                    timeoutId = setTimeout(function () { return controller.abort(); }, TIMEOUT_MS);
                    transactions = transactions.map(function (txn, idx) {
                        var vTxn = VersionedTransaction.deserialize(bs58.decode(txn));
                        try {
                            vTxn.sign([keypair]);
                            console.log('Executing Order SOLANA, after signing:', idx);
                            return bs58.encode(vTxn.serialize());
                        }
                        catch (e) {
                            console.log('Executing Order Txn signing error:', e.message, idx);
                            return txn;
                        }
                    });
                    console.log('Executing Order SOLANA, is this even logging?');
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 11, 12, 13]);
                    if (!(transactions.length === 1)) return [3 /*break*/, 5];
                    console.log('Executing Order SOLANA, single transaction, about to add priority fees');
                    // if (!hasFeesAdded) {
                    //   transactions = await Promise.all(
                    //     transactions.map(async (txn) => {
                    //       try {
                    //         const vTxn = await addPriorityFeesToTransaction(txn);
                    //         //check txn size
                    //         const size = vTxn.serialize().length;
                    //         if (size >= 1232) {
                    //           return txn;
                    //         }
                    //         vTxn.sign([keypair]);
                    //         return bs58.encode(vTxn.serialize());
                    //       } catch (e) {
                    //         console.log('Executing Order Txn signing error after adding feeds:', e);
                    //         return txn;
                    //       }
                    //     })
                    //   );
                    // }
                    console.log('Executing Order SOLANA, single transaction, after adding priority fees');
                    directResultPromise = function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            console.log('Executing Order is this even logging 0?');
                            try {
                                return [2 /*return*/, executeSolana({
                                        connection: connection,
                                        transactionString: transactions === null || transactions === void 0 ? void 0 : transactions[0],
                                        awaitConfirmation: false,
                                    })];
                            }
                            catch (e) {
                                console.log('Executing Order SOLANA sending direct error:', e);
                                return [2 /*return*/, {
                                        txHash: null,
                                        error: e,
                                    }];
                            }
                            return [2 /*return*/];
                        });
                    }); };
                    versionedTxns_1 = transactions.map(function (txn) {
                        return VersionedTransaction.deserialize(bs58.decode(txn));
                    });
                    console.log('Executing Order SOLANA sending jito bundle single', versionedTxns_1);
                    bundleResultPromise = function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            console.log('Executing Order is this even logging?');
                            try {
                                return [2 /*return*/, bundle(versionedTxns_1, keypair, connection)];
                            }
                            catch (e) {
                                console.log('Executing Order SOLANA sending jito bundle single error:', e);
                                return [2 /*return*/, [
                                        {
                                            status: 'error',
                                            hash: null,
                                            explorerUrl: null,
                                        },
                                    ]];
                            }
                            return [2 /*return*/];
                        });
                    }); };
                    return [4 /*yield*/, Promise.all([
                            directResultPromise(),
                            bundleResultPromise(),
                        ])];
                case 2:
                    _c = _k.sent(), directResult = _c[0], bundleResult = _c[1];
                    console.log('Executing Order SOLANA jitoresults single', { bundleResult: bundleResult });
                    hashes = (_d = bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult.map(function (result) { return result === null || result === void 0 ? void 0 : result.hash; })) === null || _d === void 0 ? void 0 : _d.filter(function (hash) { return hash; });
                    jitoHash = hashes === null || hashes === void 0 ? void 0 : hashes[0];
                    directHash = directResult === null || directResult === void 0 ? void 0 : directResult.txHash;
                    hash = jitoHash || directHash;
                    console.log('Executing Order SOLANA jito results and direct single', {
                        jitoHash: jitoHash,
                        directHash: directHash,
                        directResult: directResult,
                    });
                    if (!hash)
                        throw new Error('Transaction hash is null');
                    result = {
                        txHash: jitoHash,
                        explorerUrl: "https://solscan.io/tx/".concat(hash),
                        error: null,
                        bundleId: (_e = bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult[0]) === null || _e === void 0 ? void 0 : _e.bundleId,
                    };
                    if (!waitForConfirmation) return [3 /*break*/, 4];
                    return [4 /*yield*/, confirmTransactionWithTimeout(connection, hash, controller.signal)];
                case 3:
                    _k.sent();
                    _k.label = 4;
                case 4: return [3 /*break*/, 10];
                case 5:
                    console.log('Executing Order SOLANA, bundle transactions');
                    versionedTxns = transactions.map(function (txn) {
                        return VersionedTransaction.deserialize(bs58.decode(txn));
                    });
                    return [4 /*yield*/, bundle(versionedTxns, keypair, connection)];
                case 6:
                    bundleResult = _k.sent();
                    if (!(bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult.error)) return [3 /*break*/, 7];
                    throw new Error(bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult.error);
                case 7:
                    hashes = (_f = bundleResult.map(function (result) { return result === null || result === void 0 ? void 0 : result.hash; })) === null || _f === void 0 ? void 0 : _f.filter(function (hash) { return hash; });
                    if (!waitForConfirmation) return [3 /*break*/, 9];
                    return [4 /*yield*/, Promise.all(hashes === null || hashes === void 0 ? void 0 : hashes.map(function (hash) { return confirmTransactionWithTimeout(connection, hash, controller.signal); }))];
                case 8:
                    _k.sent();
                    _k.label = 9;
                case 9:
                    result = {
                        bundleId: (_g = bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult[0]) === null || _g === void 0 ? void 0 : _g.bundleId,
                        txHash: hashes[0],
                        explorerUrl: "https://solscan.io/tx/".concat(hashes[0]),
                        txHash1: hashes[1],
                        explorerUrl1: "https://solscan.io/tx/".concat(hashes[1]),
                        error: null,
                    };
                    console.log('Bundle result:', bundleResult);
                    _k.label = 10;
                case 10: return [2 /*return*/, result];
                case 11:
                    error_2 = _k.sent();
                    console.log('Executing Order Error sending transactions:', error_2);
                    if (error_2.name === 'AbortError') {
                        throw new Error('Transaction confirmation timed out');
                    }
                    throw error_2;
                case 12:
                    clearTimeout(timeoutId);
                    return [7 /*endfinally*/];
                case 13: return [2 /*return*/];
            }
        });
    });
}
